/* eslint-disable @typescript-eslint/naming-convention */
export enum Fragrance {
	"香り無し",
	"香り付き",
}
